import React from "react";
import "./search-content-field.styling.scss";

const SearchContentField = ({ handleSearch, searchQuery }) => {
  return (
    <section class="dashboard-search-section">
      <div class="search-container">
        <button class="search-button">
          <i class="fad fa-search"></i>
        </button>
        <input
          onChange={handleSearch}
          value={searchQuery ? searchQuery : null}
          id="searchInput"
          name="search-input"
          type="text"
          placeholder="Søk.."
        />
      </div>
    </section>
  );
};

export default SearchContentField;
